module.exports = "/_next/static/images/tv-07061f59e5388c4d496a39d3e4cf6ef1.png";